/** 簽收單狀態：DRAFT → ESTABLISHED → COMPLETED；DRAFT／ESTABLISHED 可 cancel。 */

export const SIGN_RECEIPT_STATUS = {
  DRAFT: 'DRAFT',
  ESTABLISHED: 'ESTABLISHED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const SIGN_RECEIPT_STATUS_LABELS = {
  DRAFT: '草稿',
  ESTABLISHED: '已成立',
  COMPLETED: '已完成',
  CANCELLED: '已取消',
};

export function formatSignReceiptStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return SIGN_RECEIPT_STATUS_LABELS[status] ?? status;
}

export function canEditSignReceipt(status) {
  return status === SIGN_RECEIPT_STATUS.DRAFT;
}

export function canEstablishSignReceipt(status) {
  return status === SIGN_RECEIPT_STATUS.DRAFT;
}

export function canCompleteSignReceipt(status) {
  return status === SIGN_RECEIPT_STATUS.ESTABLISHED;
}

export function canCancelSignReceipt(status) {
  return status === SIGN_RECEIPT_STATUS.DRAFT
    || status === SIGN_RECEIPT_STATUS.ESTABLISHED;
}

/** ESTABLISHED／COMPLETED 可下載簽收 Excel。 */
export function canDownloadSignReceiptExcel(status) {
  return status === SIGN_RECEIPT_STATUS.ESTABLISHED
    || status === SIGN_RECEIPT_STATUS.COMPLETED;
}
